import React, { useEffect } from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

// Import Icons
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import { BiTimeFive, BiPhoneCall, BiChevronRight } from 'react-icons/bi';
import { GiSnowflake2 } from 'react-icons/gi'; // Cool AC icon


// Import AOS animation library
import AOS from 'aos';
import 'aos/dist/aos.css';
import logo1 from '../assets/logo.png';

const Footer = () => {
  // Initialize AOS animations on component mount
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration in ms
      once: true,     // Whether animation should happen only once
      easing: 'ease-in-out-quart',
    });
  }, []);

  return (
    <footer className="skybreeze-footer">
      
      {/* === TOP NEWSLETTER SECTION ===
      <div className="footer-newsletter">
        <div className="newsletter-text" data-aos="fade-right">
          <h2>Stay Cool With Our Updates</h2>
          <p>Subscribe to the SkyBreeze newsletter for expert AC maintenance tips, exclusive offers, and seasonal discounts.</p>
        </div>
        
        <div className="newsletter-form-container" data-aos="fade-left" data-aos-delay="200">
          <form className="newsletter-form">
            <input type="email" placeholder="Enter your email address..." required />
            <button type="submit">Subscribe Now</button>
          </form>
        </div>
      </div>
 */}
      {/* === MAIN FOOTER CONTENT SECTION === */}
      <div className="footer-main">
        {/* VFX Background Layers */}
        <div className="footer-overlay"></div>
        <div className="footer-vfx-mist"></div>

        <div className="footer-content grid-4-columns">

          {/* COLUMN 1: Logo and About */}
          <div className="footer-col col-about" data-aos="fade-up">
           <div className="top-left">
          <img src={logo1} alt="Skybreeze Logo" className="logo-img" />
          {/* <h1 className="brand-name">SKYBREEZE AC SOLUTION</h1> */}
          <h5 style={{color:"white"}}>SKYBREEZE AC SOLUTION</h5>
        </div>
            <p className="footer-about-text">
              Your trusted partner for premium air conditioning solutions. We ensure your environment stays comfortable, efficient, and breezy all year round.
            </p>
            <div className="social-links">
              <a href="https://www.facebook.com/profile.php?id=61587039728926" target="_blank" className="social-icon"><FaFacebookF /></a>
              <a href="https://www.instagram.com/skybreezeacsolutions2026/" target="_blank" className="social-icon"><FaInstagram /></a>
              <a href="https://www.linkedin.com/in/prakash-shanmugaraj-141a8b355/" target="_blank" className="social-icon"><FaLinkedinIn /></a>
            </div>
          </div>

          {/* COLUMN 2: Navigation */}
          <div className="footer-col col-nav" data-aos="fade-up" data-aos-delay="150">
            <h3>Navigation</h3>
            <ul className="footer-links">
              <li><Link to="/" ><BiChevronRight className="link-arrow"/> Home</Link></li>
              <li><Link to="/about" ><BiChevronRight className="link-arrow"/> About Us</Link></li>
              <li><Link to="/service" ><BiChevronRight className="link-arrow"/> Our Services</Link></li>
              <li><Link to="/projects" ><BiChevronRight className="link-arrow"/> Projects</Link></li>
              <li><Link to="/products" ><BiChevronRight className="link-arrow"/> Products</Link></li>
            </ul>
          </div>

          {/* COLUMN 3: Quick Services */}
          <div className="footer-col col-services" data-aos="fade-up" data-aos-delay="300">
            <h3>AC Services</h3>
            <ul className="footer-links">
              <li><a ><BiChevronRight className="link-arrow"/> Installation</a></li>
              <li><a ><BiChevronRight className="link-arrow"/> Repair & Fixes</a></li>
              <li><a ><BiChevronRight className="link-arrow"/> Breackdown Maintenance</a></li>
              <li><a ><BiChevronRight className="link-arrow"/> Commercial HVAC</a></li>
              <li><a ><BiChevronRight className="link-arrow"/> Duct manufacturing</a></li>
            </ul>
          </div>

          {/* COLUMN 4: Work Hours & Contact */}
          <div className="footer-col col-contact" data-aos="fade-up" data-aos-delay="450">
            <h3>Work Hours</h3>
            <div className="work-hours">
              <p>We are ready to serve you during these hours:</p>
              <p><BiTimeFive color="var(--fb-accent-cyan)"/> Mon - Sat: 8:00 AM - 7:00 PM</p>
              <p><BiTimeFive color="var(--fb-accent-cyan)"/> Sunday: Emergency Only</p>
              <br />
    Contact Us: +91 93841 77714
            </div>
            
            {/* Premium Animated Call Button */}
            <a
  href="https://wa.me/+919384177714"
  className="call-btn"
  target="_blank"
  rel="noopener noreferrer"
>
  <BiPhoneCall size={24}/> WhatsApp Us
</a>
          </div>
        </div>

        {/* === COPYRIGHT BAR === */}
        <div className="copyright-bar" data-aos="fade-in" data-aos-delay="600" data-aos-offset="0">
          <p>© {new Date().getFullYear()} SkyBreeze AC Solutions. All Rights Reserved. Premium Cooling Partner.</p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;